import { Children, useLayoutEffect, useRef, useState } from "react";
import "./creditLinesViewport.css";

const VISIBLE_LINES = 4;

export default function CreditLinesViewport({
  children,
  enabled = true,
  label = "Credit lines",
}) {
  const viewportRef = useRef(null);
  const [height, setHeight] = useState(null);
  const rows = Children.toArray(children);
  const rowKeys = rows.map((row) => row.key).join("|");
  const scrollable = enabled && rows.length > VISIBLE_LINES;

  useLayoutEffect(() => {
    const viewport = viewportRef.current;
    if (!scrollable || !viewport) {
      setHeight(null);
      return undefined;
    }
    const visibleRows = Array.from(viewport.children).slice(0, VISIBLE_LINES);
    const measure = () => {
      const first = visibleRows[0];
      const last = visibleRows[VISIBLE_LINES - 1];
      const nextHeight =
        last.getBoundingClientRect().bottom -
        first.getBoundingClientRect().top +
        (parseFloat(window.getComputedStyle(first).marginTop) || 0);
      if (nextHeight > 0) setHeight(Math.ceil(nextHeight));
    };
    measure();
    window.addEventListener("resize", measure);
    const observer =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(measure)
        : null;
    visibleRows.forEach((row) => observer?.observe(row));
    return () => {
      window.removeEventListener("resize", measure);
      observer?.disconnect();
    };
  }, [scrollable, rowKeys]);

  if (!enabled) return children;
  return (
    <div
      ref={viewportRef}
      className={`credit-lines-viewport${scrollable ? " is-scrollable" : ""}`}
      style={scrollable && height ? { maxHeight: `${height}px` } : undefined}
      tabIndex={scrollable ? 0 : undefined}
      role={scrollable ? "region" : undefined}
      aria-label={scrollable ? label : undefined}
    >
      {children}
    </div>
  );
}
